import styled from "styled-components";

export const StyledDashboard = styled.div`
  .dashboard-container {
    width: calc(100% - 2px);
    height: max-content;
    border: 1px solid #e8e8e8;
    display: flex;
    flex-flow: column nowrap;
    .button-wrap {
      display: flex;
      flex-flow: row nowrap;
      & > button {
        box-sizing: border-box;
        width: 100%;
        height: 54px;
        border: none;
        border-right: 1px solid #e8e8e8;
        border-bottom: 1px solid #e8e8e8;
        padding: 0;
        background-color: #fafafb;
        font-size: 15px;
        font-weight: 700;
        line-height: 18px;
        color: #666;
        cursor: pointer;
        &:last-child {
          border-right: none;
        }
        &.active {
          border-bottom: none;
          background-color: transparent;
          color: #333;
        }
      }
    }
    .content-wrap {
      width: calc(100% - 64px);
      height: auto;
      padding: 16px 32px;
      .wrap {
        display: flex;
        justify-content: center;
        gap: 24px;
        padding: 24px 0;
        width: 100%;
        height: auto;
        .line {
          display: block;
          width: 1px;
          background-color: #e8e8e8;
        }
        &.top {
          border-bottom: 1px solid #e8e8e8;
          .box {
            width: 100%;
            display: flex;
            flex-flow: column nowrap;
            gap: 16px;

            .part {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .label {
                text-align: start;
                font-size: 16px;
                font-weight: 600;
                color: #3d3d3d;
              }
              .value {
                font-size: 28px;
                font-weight: 700;
                line-height: 32px;
              }

              &.operation .value {
                color: #4679cc;
              }
              &.receive .value {
                color: #ffba28;
              }
              &.inspected .value {
                color: #fd3995;
              }
              &.detected .value {
                color: #2cc6b6;
              }
            }
          }
        }
        &.bottom {
          flex-flow: row wrap;
          .box {
            width: 46%;
            display: flex;
            flex-flow: column nowrap;
            gap: 24px;
            .title {
              font-size: 16px;
              font-weight: 700;
              line-height: 24px;
              color: #4679cc;
              background-color: transparent;
              width: max-content;
              border: 1px solid #4679cc;
              margin: 0 auto;
              padding: 2px 8px;
              border-radius: 4px;
            }
            .inner-box {
              flex-shrink: 0;
              display: flex;
              justify-content: space-between;
              height: 34px;
              & > p {
                color: #3d3d3d;
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
              }
            }
          }
        }
      }
    }
  }
`;
